import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import CreatableReactSelect from 'react-select/creatable';
import usePotionSelectProps from './use-potion-select-props';
const CreatableSelect = forwardRef((props, ref) => {
    const potionSelectProps = usePotionSelectProps(props);
    return _jsx(CreatableReactSelect, Object.assign({ ref: ref }, potionSelectProps), void 0);
});
export default CreatableSelect;
